export default __webpack_public_path__ + "static/media/mentalic.ac576698.jfif";